"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEvidenceItemRedirect = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const navigation_context_1 = require("../../navigation/navigation-context");
const evidence_types_1 = require("../evidence-types");
function useEvidenceItemRedirect() {
    const { id } = (0, react_router_dom_1.useParams)();
    const route = (0, react_router_dom_1.useRouteMatch)();
    const { search } = (0, react_router_dom_1.useLocation)();
    const params = new URLSearchParams(search);
    const { navigate } = (0, react_1.useContext)(navigation_context_1.NavigationContext);
    const animationIdRef = (0, react_1.useRef)();
    (0, react_1.useLayoutEffect)(() => {
        if (id !== undefined) {
            animationIdRef.current = requestAnimationFrame(() => {
                const query = params.toString();
                navigate(route.path.replace(':id', id) + query, true, {
                    action: evidence_types_1.EvidenceStateAction.SHOW_ITEM,
                    data: id,
                });
            });
        }
        return () => {
            if (animationIdRef.current) {
                cancelAnimationFrame(animationIdRef.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
exports.useEvidenceItemRedirect = useEvidenceItemRedirect;
//# sourceMappingURL=item-redirect-hook.js.map